module.exports = __webpack_public_path__ + "dashboard/img/prezentacja_d.d3f4168c8279de3efd4b83eb766683fc.svg";